"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatisticRequest = void 0;
var StatisticRequest = /** @class */ (function () {
    function StatisticRequest() {
    }
    return StatisticRequest;
}());
exports.StatisticRequest = StatisticRequest;
//# sourceMappingURL=statistic.request.js.map